module.exports = __webpack_public_path__ + "static/media/b4.abd3cc99.jpg";